<template>
  <div>
    <v-select
      color="black"
      :items="autores"
      label="Autor"
      item-value="id"
      v-bind="$attrs"
      v-on="$listeners"
      dense
    >
      <template slot="selection" slot-scope="{ item }">
        <v-row style="align-items: center;">
          <v-col cols="2">
            <v-avatar size="32px">
              <v-img :src="item.foto" v-if="!!item.foto && item.foto !== 'null'"></v-img>
              <v-icon large v-else>mdi-account-circle</v-icon>
            </v-avatar>
          </v-col>
          <v-col cols="10">
            {{ item.nome }}
          </v-col>
        </v-row>
      </template>
      <template slot="item" slot-scope="{ item }">
        <v-row>
          <v-col cols="2">
            <v-avatar size="32px">
              <v-img :src="item.foto" v-if="!!item.foto && item.foto !== 'null'"></v-img>
              <v-icon large v-else>mdi-account-circle</v-icon>
            </v-avatar>
          </v-col>
          <v-col cols="10" class="mt-2">
            {{ item.nome }}
          </v-col>
        </v-row>
      </template>
    </v-select>
  </div>
</template>

<script>
import AutorService from "../services/autorService";
export default {
  prop: ['value', 'v-model'],
  data() {
    return {
      autores: [],
    }
  },
  methods: {
    async carregarAutores() {
      var result = await AutorService.listarAutor();
      this.autores = result.data.data.listarAutor;
    }
  },
  created() {
      this.carregarAutores();
  },
};
</script>

<style lang="scss" scoped>
</style>
